// The one date format used across the web app (LEAD-05): "Oct 12, 2026".
// Always en-US regardless of browser locale. Returns "" for missing/invalid input.
export function formatDate(value) {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export default formatDate;
